import AdminPanel from "./AdminPanel";

function App() {
  return <AdminPanel />;
}

export default App;